import React from 'react';
import cx from 'classnames';
import Input from '../../../../../components/Input';
import { FormStep } from '../../../../../types/ContactForm';
import styles from '../FieldsTab.module.scss';

interface SimpleStepHeaderProps {
    step: FormStep | undefined;
    showDescription: boolean;
    onToggleDescription: () => void;
    onUpdateTitle: (title: string) => void;
    onUpdateDescription: (description: string) => void;
}

export const SimpleStepHeader: React.FC<SimpleStepHeaderProps> = ({
    step,
    showDescription,
    onToggleDescription,
    onUpdateTitle,
    onUpdateDescription
}) => {
    return (
        <div className={cx(styles['step-header-simple'])}>
            <div className={cx(styles['step-inputs-simple'])}>
                <div>
                    <Input
                        type="text"
                        property="title"
                        value={step?.title || ''}
                        onChange={(_, value) => onUpdateTitle(value)}
                        placeholder="Schritt Titel"
                    />
                </div>
                <div>
                    <div className={cx(styles['description-toggle-container'], 'zr-mb-3')}>
                        <button
                            type="button"
                            className={cx(styles['toggle-description-btn'])}
                            onClick={onToggleDescription}
                        >
                            {showDescription ? 'Beschreibung ausblenden' : 'Beschreibung hinzufügen'}
                        </button>
                    </div>
                    {showDescription && (
                        <div className={cx(styles['description-input-container'])}>
                            <Input
                                type="textarea"
                                property="description"
                                value={step?.description || ''}
                                onChange={(_, value) => onUpdateDescription(value)}
                                placeholder="Schritt Beschreibung (optional)"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

